import { render, staticRenderFns } from "./mem_favorite.vue?vue&type=template&id=234c1e5f&scoped=true&"
import script from "./mem_favorite.vue?vue&type=script&lang=js&"
export * from "./mem_favorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c1e5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234c1e5f')) {
      api.createRecord('234c1e5f', component.options)
    } else {
      api.reload('234c1e5f', component.options)
    }
    module.hot.accept("./mem_favorite.vue?vue&type=template&id=234c1e5f&scoped=true&", function () {
      api.rerender('234c1e5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/favorite/mem_favorite.vue"
export default component.exports